import React, { useState, useContext } from 'react';
import { ButtonFilled } from 'components/ui/Button';
import SocketContext from 'utils/hooks/useSocket';
import { editMargin } from 'api/socketService';
import { CASH_TICKER } from 'utils/cash';

import {
  TitleModal,
  TextModal,
  Row,
  Text,
  Amount,
  InputText,
  ButtonModal,
  LoadButton,
  LoadWrap,
  Wrap,
  ErrorText,
} from './styled';

interface SetTPSLProps {
  takeProfit: any;
  setTakeProfit: (value: any) => void;
  stopLoss: any;
  setStopLoss: (value: any) => void;
  onAccept: () => void;
  onCancel: () => void;
  tradeId: number | null;
}

const SetTPSL = ({ takeProfit, setTakeProfit, stopLoss, setStopLoss, onAccept, onCancel, tradeId }: SetTPSLProps) => {
  const { selectedCoinValue, selectedCoin } = useContext(SocketContext);
  const [isTrading, setIsTrading] = useState(false);
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  let shortNameSelectedCoin = selectedCoin?.name?.split('/')[0];
  const rawPrice = (selectedCoinValue as any)?.last;
  const price = typeof rawPrice === 'number' && Number.isFinite(rawPrice) && rawPrice > 0 ? rawPrice : 0;

  const handleAccept = () => {
    setErrorMsg(null);

    if (!tradeId) {
      onAccept();
      return;
    }

    const editPayload = {
      stopLoss: Number(stopLoss) || undefined,
      takeProfit: Number(takeProfit) || undefined,
      id: tradeId,
    };

    setIsTrading(true);
    editMargin(editPayload, (response: any) => {
      setIsTrading(false);
      if (response?.success) {
        onAccept();
      } else {
        const nextError = response?.error || 'Unable to update take profit / stop loss';
        setErrorMsg(nextError);
        console.error('Error editing margin:', nextError);
      }
    });
  };

  const handleTakeProfitChange = (value: string) => {
    if (errorMsg) setErrorMsg(null);
    setTakeProfit(value);
  };

  const handleStopLossChange = (value: string) => {
    if (errorMsg) setErrorMsg(null);
    setStopLoss(value);
  };

  return (
    <Wrap>
      <TitleModal>Take Profit / Stop Loss</TitleModal>
      <TextModal>Lock in profits with TP, limit losses with SL</TextModal>
      <Row className="DarkInfo">
        <Text>Market price</Text>
        <Amount>{price} {CASH_TICKER}</Amount>
      </Row>
      <Row className="RowInput">
        <Text className="TextSpecial">Take Profit </Text>
        <InputText
          type="number"
          pattern="\d*(\.\d+)?"
          step="0.0001"
          min="0"
          value={takeProfit}
          onChange={(e) => handleTakeProfitChange(e.target.value)}
          aria-invalid={!!errorMsg}
          aria-describedby={errorMsg ? 'tpsl-error' : undefined}
        />
        <Amount className="AmountSpecial">{shortNameSelectedCoin}</Amount>
      </Row>

      <Row className="RowInput">
        <Text className="TextSpecial">Stop Loss</Text>
        <InputText
          type="number"
          pattern="\d*(\.\d+)?"
          step="0.0001"
          min="0"
          value={stopLoss}
          onChange={(e) => handleStopLossChange(e.target.value)}
          aria-invalid={!!errorMsg}
          aria-describedby={errorMsg ? 'tpsl-error' : undefined}
        />
        <Amount className="AmountSpecial">{shortNameSelectedCoin}</Amount>
      </Row>

      {errorMsg && (
        <ErrorText id="tpsl-error" role="alert" aria-live="polite">
          {errorMsg}
        </ErrorText>
      )}

      <ButtonModal>
        <div>
          {isTrading ?
            <LoadButton>
              <ButtonFilled className="buttonLoad" disabled={true} type="button"><LoadWrap></LoadWrap> Loading...</ButtonFilled>
            </LoadButton>
          :
            <ButtonFilled
              type="button"
              onClick={onCancel}
            >
              Cancel
            </ButtonFilled>
          }
        </div>
        <div>
          {isTrading ?
            <LoadButton>
              <ButtonFilled className="buttonLoad" disabled={true} type="button"><LoadWrap></LoadWrap> Loading...</ButtonFilled>
            </LoadButton>
          :
            <ButtonFilled
              type="button"
              onClick={handleAccept}
            >
              Save
            </ButtonFilled>
          }
        </div>
      </ButtonModal>
    </Wrap>
  );
};

export default SetTPSL;
